<template>
  <div class="profile-page">
     <v-content>
      <v-container fluid fill-height>
       <h1>Profile</h1>
      </v-container>
    </v-content>
  </div>
</template>

<script>
export default {
  name: 'ProfilePage'
}
</script>